import PlaceMapData from './PlaceMapData'
import React, { useState } from 'react'
import Header from './Header'
import List from './List'
import Map from './Map'
import './style.scss'

const PlaceMap: React.FC = () => {
  const [isMap, showMap] = useState(true)
  return (
    <PlaceMapData showMap={showMap}>
      <div className='placeMap'>
        <Header
          isMap={isMap}
          showMap={showMap}
        />
        {isMap
          ? <Map />
          : <List />}
      </div>
    </PlaceMapData>
  )
}

export default PlaceMap